import cn from "classnames"

import { Flex, Text } from "@/atoms"
import * as vulnerabilityDomain from "@/domain/vulnerability"
import { GHSAIcon, KodemDark, NVDIcon, OSVIcon } from "../Icon"

import styles from "./VulnerabilityProviderIcon.module.scss"

import type { VulnerabilityProviderIconProps } from "./VulnerabilityProviderIcon.types"

const PROVIDER_CONFIG = [
  { check: vulnerabilityDomain.isCveRisk, label: "NVD", Icon: NVDIcon },
  { check: vulnerabilityDomain.isGhsaRisk, label: "GHSA", Icon: GHSAIcon },
  { check: vulnerabilityDomain.isKodemRisk, label: "Kodem", Icon: KodemDark },
  { check: vulnerabilityDomain.isMalRisk, label: "MAL", Icon: OSVIcon }
] as const

export const VulnerabilityProviderIcon = ({
  riskId,
  expanded,
  className,
  ...props
}: VulnerabilityProviderIconProps) => {
  if (!riskId) return null

  const provider = PROVIDER_CONFIG.find(({ check }) => check(riskId))

  if (!provider) return null

  const { label, Icon } = provider

  return (
    <Flex gap={4} align="center" className={cn(styles.content, className)}>
      <Icon {...props} />
      {expanded && <Text>{label}</Text>}
    </Flex>
  )
}
